import { gql } from 'graphql-request'

export const GET_SEARCH_RESULT_BY_TAG = gql`
  query GetSearchResultByTag(
    $dateRange: DatePicker
    $limitPerPage: Int
    $page: Int
    $orderBy: SearchByTagSort
    $orderDirection: OrderDirection
  ) {
    searchResultByTag(
      dateRange: $dateRange
      limitPerPage: $limitPerPage
      page: $page
      orderBy: $orderBy
      orderDirection: $orderDirection
    ) {
      data {
        tag
        totalSearch
      }
      page
    }
  }
`
